import React from 'react'

// Components
import IconsSwitch from '../../../components/IconsSwitch/_index'
import ImageWebp from '../../../components/ImageWebp/index'

// Hooks
import useDataLayer from '../../../hooks/useDataLayer/dataLayerBody'
import useWidth from '../../../hooks/window/useWidth'
import { WIDTH_MD, WIDTH_XL } from '../../../utils/breakpoints'

// Assets
import * as S from './style'

const RuleOf50 = () => {
  const width = useWidth()
  const [ sendDatalayerEvent ] = useDataLayer()
  const imageLG = 'https://central-imagens.bancointer.com.br/75319a00/rule-of-50-lg.webp'
  const imageXL = 'https://central-imagens.bancointer.com.br/03a98635/rule-of-50-xl.webp'

  const image = width > WIDTH_XL ? imageXL : imageLG

  return (
    <S.Section role='img' aria-label='Sede do Inter em Belo Horizonte'>
      <div className='container pr-lg-0'>
        <div className='row align-items-center'>
          <div className='col-12'>
            <S.Title>
              Rule of 50: plano estratégico pra acelerar nosso futuro
            </S.Title>
            <S.Description>
              Nossa meta é alcançar, nos próximos três anos, uma combinação de crescimento de receita e rentabilidade que some 50%.
            </S.Description>
          </div>
        </div>
        <div className='row margin-text'>
          <div className='col-12 col-md-6'>
            <S.ListTitle>
              Pra chegar lá, nosso foco é simples e poderoso:
            </S.ListTitle>
            <S.ContentItems>
              <div>
                <IconsSwitch
                  icon='ic_credit_card'
                  width='24'
                  height='24'
                  color='#FFFFFF'
                  lib='interco'
                  customPath='finance/'
                />
              </div>
              <div>
                <S.ListDescription>
                  Mais pessoas usando nossas soluções de crédito
                </S.ListDescription>
              </div>
            </S.ContentItems>
            <S.ContentItems>
              <div>
                <IconsSwitch
                  icon='ic_hand_money'
                  width='24'
                  height='24'
                  color='#FFFFFF'
                  lib='interco'
                  customPath='human/'
                />
              </div>
              <div>
                <S.ListDescription>
                  Mais clientes trazendo sua vida financeira pra cá
                </S.ListDescription>
              </div>
            </S.ContentItems>
            <S.ContentItems>
              <div>
                <IconsSwitch
                  icon='ic_inter'
                  width='24'
                  height='24'
                  color='#FFFFFF'
                  lib='interco'
                  customPath='brands/'
                />
              </div>
              <div>
                <S.ListDescription>
                  Mais clientes escolhendo o Inter como principal instituição financeira
                </S.ListDescription>
              </div>
            </S.ContentItems>
            <S.Paragraph>
              Para tirar esse plano do papel, contamos com diferenciais que só o Inter tem: nosso Super App cada vez mais integrado, uma base de dados poderosa e a Seven, nossa nova assistente de IA que vai revolucionar a sua vida financeira.
            </S.Paragraph>
            <S.Btn
              onClick={() => {
                sendDatalayerEvent({
                  section: 'dobra_3',
                  element_action: 'click button',
                  element_name: 'Confira nossas vagas',
                  section_name: 'Rule of 50: plano estratégico pra acelerar nosso futuro',
                  redirect_url: 'carreiras',
                })
              }}
              to='carreiras'
              title='Veja nossas vagas disponíveis'
              className='fs-14 fw-600 text-none mb-0 mw-100 px-5 py-2 mt-2 mt-lg-4'
            >
              Confira nossas vagas
            </S.Btn>
          </div>
          <div className='col-lg-6 d-flex justify-content-lg-end'>
            {width > WIDTH_MD &&
              <ImageWebp
                arrayNumbers={[ 440, 440, 440, 546 ]}
                arrayNumbersHeight={[ 356, 356, 356, 437 ]}
                pathSrc={image}
                altDescription=''
              />}
          </div>
        </div>
      </div>
    </S.Section>
  )
}

export default RuleOf50
